/* eslint-disable no-self-assign */
import campaign from '@/api/campaign'
import phishCampaign from '@/api/phishCampaign'
import get from 'lodash/get'

const INITIAL_STATE = {
  summary: {},
  phishCampaignList: {},
  phishCampaignsStatusTotal: {},
  phishCampaignDetails: null,
  phishCampaignChildDetails: null,
  phishCampaignChildren: {},
  phishSmsCampaignList: {},
  phishSmsCampaignsStatusTotal: {},
  phishSmsCampaignDetails: null,
  phishSmsCampaignChildDetails: null,
  phishSmsCampaignChildren: {},
  createCampaignOptions: null,
  previewCourse: null,
}

export default {
  namespace: 'phishCampaign',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setCampaignSummary(state, { payload }) {
      return { ...state, summary: payload }
    },
    setPhishCampaignList(state, { payload }) {
      return { ...state, phishCampaignList: payload }
    },
    setPhishCampaignsStatusTotal(state, { payload }) {
      return { ...state, phishCampaignsStatusTotal: payload }
    },
    setPhishCampaignDetails(state, { payload }) {
      return { ...state, phishCampaignDetails: payload }
    },
    setPhishCampaignChildDetails(state, { payload }) {
      return { ...state, phishCampaignChildDetails: payload }
    },
    setPhishSmsCampaignList(state, { payload }) {
      return { ...state, phishSmsCampaignList: payload }
    },
    setPhishSmsCampaignsStatusTotal(state, { payload }) {
      return { ...state, phishSmsCampaignsStatusTotal: payload }
    },
    setPhishSmsCampaignDetails(state, { payload }) {
      return { ...state, phishSmsCampaignDetails: payload }
    },

    setPhishSmsCampaignChildDetails(state, { payload }) {
      return { ...state, phishSmsCampaignChildDetails: payload }
    },
    setCreateCampaignOptions(state, { payload }) {
      return { ...state, createCampaignOptions: payload }
    },
    setPhishCampaignUsers(state, { payload }) {
      const { phishCampaignDetails = {} } = state

      return { ...state, phishCampaignDetails: { ...phishCampaignDetails, users: payload } }
    },
    setPhishCampaignChildUsers(state, { payload }) {
      const { phishCampaignChildDetails = {} } = state

      return {
        ...state,
        phishCampaignChildDetails: { ...phishCampaignChildDetails, users: payload },
      }
    },
    setPhishSmsCampaignUsers(state, { payload }) {
      const { phishSmsCampaignDetails = {} } = state

      return { ...state, phishSmsCampaignDetails: { ...phishSmsCampaignDetails, users: payload } }
    },
    setPhishSmsCampaignChildUsers(state, { payload }) {
      const { phishSmsCampaignChildDetails = {} } = state

      return {
        ...state,
        phishSmsCampaignChildDetails: { ...phishSmsCampaignChildDetails, users: payload },
      }
    },
    setPreviewCourse(state, { payload }) {
      return { ...state, previewCourse: payload }
    },
    setPhishCampaignChildren(state, { payload }) {
      const { phishCampaignChildren = {} } = state

      return { ...state, phishCampaignChildren: { ...phishCampaignChildren, ...payload } }
    },
    setPhishSmsCampaignChildren(state, { payload }) {
      const { phishSmsCampaignChildren = {} } = state

      return { ...state, phishSmsCampaignChildren: { ...phishSmsCampaignChildren, ...payload } }
    },
  },

  effects: {
    *getCampaignSummary({ successCallback, errorCallback }, { call, select, put }) {
      const { username } = yield select(state => state.profile)
      const response = yield call(campaign.getCampaignSummary, { params: { email: username } })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          yield put({ type: 'campaign/setCampaignSummary', payload: data })
          hasError = false
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaigns({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(phishCampaign.getPhishCampaigns, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishCampaignList', payload: resData })
        successCallback?.(resData)
      }

      if (hasError) {
        errorCallback?.()
      }
    },

    // 下拉選單用輕量查詢：結果只交給 successCallback，不寫入 phishCampaignList，
    // 避免無統計欄位的資料覆蓋釣魚活動列表頁的 store
    *getPhishCampaignOptions({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(phishCampaign.getPhishCampaignOptions, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      if (status === 200) {
        successCallback?.(resData)
      } else {
        errorCallback?.()
      }
    },

    *getPhishCampaignChildren({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignId, ...params } = payload

      const response = yield call(phishCampaign.getPhishCampaignChildren, {
        campaignId,
        params: { params: { ...params, accountId: get(account, 'accountId') } },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        const putPayload = {}

        putPayload[campaignId] = resData.data

        yield put({ type: 'phishCampaign/setPhishCampaignChildren', payload: putPayload })
        successCallback?.(resData)
      }

      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignsStatusTotal(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.getPhishCampaignsStatusTotal, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishCampaignsStatusTotal', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignDetails({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const { campaignId } = payload

      const response = yield call(phishCampaign.getPhishCampaignDetails, {
        campaignId,
        params: { params: { accountId: get(account, 'accountId') } },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishCampaignDetails', payload: data })

          successCallback?.(data)
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignChildDetails(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const { campaignId } = payload

      const response = yield call(phishCampaign.getPhishCampaignChildDetails, {
        campaignId,
        params: { params: { accountId: get(account, 'accountId') } },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishCampaignChildDetails', payload: data })

          successCallback?.(data)
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignChildDetails(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const { campaignId } = payload

      const response = yield call(phishCampaign.getPhishSmsCampaignChildDetails, {
        campaignId,
        params: { params: { accountId: get(account, 'accountId') } },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishSmsCampaignChildDetails', payload: data })

          successCallback?.(data)
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaigns({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(phishCampaign.getPhishSmsCampaigns, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishSmsCampaignList', payload: resData })
        successCallback?.(resData)
      }

      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignChildren(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const { campaignId, ...params } = payload

      const response = yield call(phishCampaign.getPhishSmsCampaignChildren, {
        campaignId,
        params: { params: { ...params, accountId: get(account, 'accountId') } },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        const putPayload = {}

        putPayload[campaignId] = resData.data

        yield put({ type: 'phishCampaign/setPhishSmsCampaignChildren', payload: putPayload })
        successCallback?.(resData)
      }

      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignsStatusTotal(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.getPhishSmsCampaignsStatusTotal, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishSmsCampaignsStatusTotal', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignDetails(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const { campaignId } = payload

      const response = yield call(phishCampaign.getPhishSmsCampaignDetails, {
        campaignId,
        params: { params: { accountId: get(account, 'accountId') } },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success, data } = resData
        if (success) {
          hasError = false

          yield put({ type: 'phishCampaign/setPhishSmsCampaignDetails', payload: data })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignUsers({ payload, successCallback, errorCallback }, { select, call, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.getPhishCampaignUsers, {
        ...payload,
        params: { ...payload.params, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishCampaignUsers', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignChildUsers(
      { payload, successCallback, errorCallback },
      { select, call, put },
    ) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.getPhishCampaignChildUsers, {
        ...payload,
        params: { ...payload.params, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishCampaignChildUsers', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignUsers({ payload, successCallback, errorCallback }, { call, put }) {
      const response = yield call(phishCampaign.getPhishSmsCampaignUsers, {
        ...payload,
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishSmsCampaignUsers', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishSmsCampaignChildUsers(
      { payload, successCallback, errorCallback },
      { select, call, put },
    ) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.getPhishSmsCampaignChildUsers, {
        ...payload,
        params: { ...payload.params, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        hasError = false

        yield put({ type: 'phishCampaign/setPhishSmsCampaignChildUsers', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *sendPhishCampaignTest({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.sendPhishCampaignTest, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData

        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *createPhishCampaign({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.createPhishCampaign, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      // eslint-disable-next-line no-unused-vars
      const { status, data: resData } = response

      const { success, message } = resData

      if (success) {
        // error = undefined
        successCallback?.()
      } else {
        yield put({ type: 'app/notify', payload: { message: message ?? null, severity: 'error' } })
        errorCallback?.(message ?? null)
      }
    },

    *updatePhishCampaign({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const { campaignId, campaignMainId, campaignName, campaignMainName, ...params } = payload
      const finalCampaignId = campaignId || campaignMainId
      const finalCampaignName = campaignName || campaignMainName

      const response = yield call(phishCampaign.updatePhishCampaign, {
        finalCampaignId,
        params: {
          accountId: get(account, 'accountId'),
          campaignName: finalCampaignName,
          ...params,
        },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *deletePhishCampaign({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.deletePhishCampaign, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *deletePhishCampaignMain({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(phishCampaign.deletePhishCampaignMain, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },
  },
}
